/**
 * Pixel Hobby | Customs notice
 *
 * Shows or hides the "customs fees may apply" notice as the customer switches
 * variant. Whether a variant is held in one of our own warehouses can only be
 * resolved in Liquid (it comes from a metafield written by a Shopify Flow
 * automation), so this element does no logic of its own - it just reads the
 * per-variant map that Liquid rendered and toggles visibility.
 */
if (!customElements.get('pixel-hobby-customs')) {
  customElements.define('pixel-hobby-customs', class extends HTMLElement {
    connectedCallback() {
      this.variantMap = this.getVariantMap();
      if (!this.variantMap) return;

      this.section = this.closest('.js-product') || this.closest('.product') || document;
      this.picker = this.section.querySelector('variant-picker');
      if (!this.picker) return;

      this.onVariantChange = this.handleVariantChange.bind(this);
      this.picker.addEventListener('on:variant:change', this.onVariantChange);
    }

    disconnectedCallback() {
      if (this.picker && this.onVariantChange) {
        this.picker.removeEventListener('on:variant:change', this.onVariantChange);
      }
    }

    /**
     * Reads the variant -> customs map rendered by Liquid.
     * @returns {?object} Map of variant id to customs boolean, or null.
     */
    getVariantMap() {
      try {
        const parsed = JSON.parse(this.dataset.variants || '[]');
        if (!Array.isArray(parsed)) return null;

        return parsed.reduce((map, item) => {
          map[String(item.id)] = item.customs === true;
          return map;
        }, {});
      } catch (e) {
        // Malformed data: leave the server rendered state untouched rather
        // than risk hiding a notice that should be showing.
        return null;
      }
    }

    /**
     * Handles a variant change on the product form.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      const variant = evt.detail && evt.detail.variant;
      if (!variant) return;

      const customs = this.variantMap[String(variant.id)];
      if (typeof customs !== 'boolean') return;

      this.hidden = !customs;
    }
  });
}
